// extracted by mini-css-extract-plugin
export default {"container":"top_limitation-module__container--3clY3","link":"top_limitation-module__link--2Tu4E"};